/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartTypeMeasurementToolResponse } from './PartTypeMeasurementToolResponse';
import {
    PartTypeMeasurementToolResponseFromJSON,
    PartTypeMeasurementToolResponseFromJSONTyped,
    PartTypeMeasurementToolResponseToJSON,
    PartTypeMeasurementToolResponseToJSONTyped,
} from './PartTypeMeasurementToolResponse';
import type { ObservableItemActionTypeResponse } from './ObservableItemActionTypeResponse';
import {
    ObservableItemActionTypeResponseFromJSON,
    ObservableItemActionTypeResponseFromJSONTyped,
    ObservableItemActionTypeResponseToJSON,
    ObservableItemActionTypeResponseToJSONTyped,
} from './ObservableItemActionTypeResponse';
import type { ObservableItemResponse } from './ObservableItemResponse';
import {
    ObservableItemResponseFromJSON,
    ObservableItemResponseFromJSONTyped,
    ObservableItemResponseToJSON,
    ObservableItemResponseToJSONTyped,
} from './ObservableItemResponse';
import type { EquipmentPartConfigurationResponse } from './EquipmentPartConfigurationResponse';
import {
    EquipmentPartConfigurationResponseFromJSON,
    EquipmentPartConfigurationResponseFromJSONTyped,
    EquipmentPartConfigurationResponseToJSON,
    EquipmentPartConfigurationResponseToJSONTyped,
} from './EquipmentPartConfigurationResponse';

/**
 * 
 * @export
 * @interface ConfigurationSyncItemsResponse
 */
export interface ConfigurationSyncItemsResponse {
    /**
     * 
     * @type {Array<ObservableItemResponse>}
     * @memberof ConfigurationSyncItemsResponse
     */
    observableItems?: Array<ObservableItemResponse>;
    /**
     * 
     * @type {Array<ObservableItemActionTypeResponse>}
     * @memberof ConfigurationSyncItemsResponse
     */
    observableItemActionTypes?: Array<ObservableItemActionTypeResponse>;
    /**
     * 
     * @type {Array<EquipmentPartConfigurationResponse>}
     * @memberof ConfigurationSyncItemsResponse
     */
    equipmentPartConfigurations?: Array<EquipmentPartConfigurationResponse>;
    /**
     * 
     * @type {Array<PartTypeMeasurementToolResponse>}
     * @memberof ConfigurationSyncItemsResponse
     */
    partTypeMeasurementTools?: Array<PartTypeMeasurementToolResponse>;
}

/**
 * Check if a given object implements the ConfigurationSyncItemsResponse interface.
 */
export function instanceOfConfigurationSyncItemsResponse(value: object): value is ConfigurationSyncItemsResponse {
    return true;
}

export function ConfigurationSyncItemsResponseFromJSON(json: any): ConfigurationSyncItemsResponse {
    return ConfigurationSyncItemsResponseFromJSONTyped(json, false);
}

export function ConfigurationSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'observableItems': json['observableItems'] == null ? undefined : ((json['observableItems'] as Array<any>).map(ObservableItemResponseFromJSON)),
        'observableItemActionTypes': json['observableItemActionTypes'] == null ? undefined : ((json['observableItemActionTypes'] as Array<any>).map(ObservableItemActionTypeResponseFromJSON)),
        'equipmentPartConfigurations': json['equipmentPartConfigurations'] == null ? undefined : ((json['equipmentPartConfigurations'] as Array<any>).map(EquipmentPartConfigurationResponseFromJSON)),
        'partTypeMeasurementTools': json['partTypeMeasurementTools'] == null ? undefined : ((json['partTypeMeasurementTools'] as Array<any>).map(PartTypeMeasurementToolResponseFromJSON)),
    };
}

export function ConfigurationSyncItemsResponseToJSON(json: any): ConfigurationSyncItemsResponse {
    return ConfigurationSyncItemsResponseToJSONTyped(json, false);
}

export function ConfigurationSyncItemsResponseToJSONTyped(value?: ConfigurationSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'observableItems': value['observableItems'] == null ? undefined : ((value['observableItems'] as Array<any>).map(ObservableItemResponseToJSON)),
        'observableItemActionTypes': value['observableItemActionTypes'] == null ? undefined : ((value['observableItemActionTypes'] as Array<any>).map(ObservableItemActionTypeResponseToJSON)),
        'equipmentPartConfigurations': value['equipmentPartConfigurations'] == null ? undefined : ((value['equipmentPartConfigurations'] as Array<any>).map(EquipmentPartConfigurationResponseToJSON)),
        'partTypeMeasurementTools': value['partTypeMeasurementTools'] == null ? undefined : ((value['partTypeMeasurementTools'] as Array<any>).map(PartTypeMeasurementToolResponseToJSON)),
    };
}

